import React from "react";
import { useTranslation } from 'react-i18next';
import { useCartContext } from "../context/CartContext";

const Navigation = ({ currentStep = 1, onStepChange }) => {
  const { t } = useTranslation();
  const { cart } = useCartContext();
  
  const getStepClass = (stepNumber) => {
    let classes = [];
    
    if (currentStep == "payment") {
      classes.push('link');
    }
    
    if (currentStep === stepNumber || (currentStep === "payment" && stepNumber === 2)) {
      classes.push('on');
    }
    
    if (stepNumber === 1) {
      if (currentStep > 1) classes.push('link');
    }
    else if (stepNumber === 2 || currentStep == "payment") {
      if (currentStep <= 2 && cart?.items?.length > 0) classes.push('link');
    }
    else if (stepNumber === 3) {
      if (currentStep > 3) classes.push('link');
    }
    
    return classes.join(' ');
  };


  const handleStepClick = (stepNumber) => {
    const isClickable = getStepClass(stepNumber).includes('link');
    
    if (isClickable) {
      onStepChange(stepNumber);
    }
    
    if (!window.location.pathname.includes("/home")) {
      window.location.href = "/home";
    }
  };

  const steps = [
    { number: 1, label: t('E-carte cadeau') },
    { number: 2, label: t('Paiement') },
    { number: 3, label: t('Confirmation') }
  ];

  return (
    <nav id="stepsNav" className="stepsNav" aria-label={t('Progression de la commande')}>
      <ul role="tablist">
        {steps.map(({ number, label }) => {
          const isCurrent = currentStep === number || (currentStep === "payment" && number === 2);
          return (
            <li key={number} role="presentation">
              <a
                href="#"
                tabIndex={isCurrent ? "0" : "-1"}
                role="tab"
                data-step={number}
                className={getStepClass(number)}
                onClick={(e) => {
                  e.preventDefault();
                  handleStepClick(number);
                }}
                aria-selected={isCurrent}
                aria-current={isCurrent ? 'step' : undefined}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleStepClick(number);
                  }
                }}
              >
                <span className="stepLabel">{label}</span>
                <span className="visually-hidden">{t('Étape')} {number} {isCurrent ? t('(actuelle)') : ''}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Navigation;